/*
 * em-swatchking-quickshop-fix.js
 * --------------------------------------------------------------------------
 * Ella & Marie / Impulse theme.
 *
 * Problem: Quick Shop (Featured Collection / product card) loads its product
 * HTML via AJAX into #QuickShopHolder-<handle> AFTER SwatchKing has already
 * initialized. SwatchKing (StarApps "Variant Swatch King") then processes that
 * modal once -- but for products whose per-product swatch data has not finished
 * fetching at that moment, it stamps the product section as done and renders an
 * EMPTY swatch box. The stamp is two guards on the product-section element:
 *   - attribute  swatch-generated="<handle>"
 *   - JS property  el.vsk_initialized = true
 * Once stamped, every later dissect()/`vsk:product:refresh` is SKIPPED
 * (guard check is `void 0 === el.vsk_initialized`), so the empty box never heals.
 * That is why multi-colour / already-cached products show swatches but others
 * (e.g. single-colour "Blumig"/"Geblümt" dresses) show an empty box.
 *
 * Fix: when a Quick Shop modal loads / opens, on the product-section element
 * inside its holder we
 *   1. clear the guards (remove `swatch-generated`, delete `vsk_initialized`),
 *   2. dispatch SwatchKing's real re-scan hook `vsk:product:refresh`
 *      (verified in variant-swatch-king-new-11-48.min.js -> re-runs dissect(),
 *      logs "Refreshing product swatch lookup complete."),
 * and retry on a short schedule until the swatches actually render -- then STOP.
 *
 * No duplicates: we clear only the product-section guard (not inner swatch
 * containers, which would also trigger the product-grid render path and create a
 * second set), and we stop the instant `.swatch-view-item` appears, so exactly
 * one swatch set is generated. No endless loop: bounded retry list + a per-holder
 * run guard. Scoped to Quick Shop holders only -> PDP swatches and the size-chart
 * popup are untouched.
 */
(function () {
  if (window.__emSwatchKingQuickShopFix) return;
  window.__emSwatchKingQuickShopFix = true;

  var HOLDER_PREFIX = 'QuickShopHolder-';
  var SECTION_SELECTOR = '[data-section-type="product"], .product-section';
  // Retries are spaced so each SwatchKing (re)generation lands and is detected
  // before the next attempt -- otherwise two clear+regenerate passes overlap and
  // SwatchKing appends a SECOND swatch set (duplicate). The user-suggested
  // 50/150/300ms cadence was too fast and caused exactly that duplication.
  var FIRST_DELAY = 150;   // let the modal/section settle after open
  var RETRY_GAP = 600;     // long enough for one generation to complete
  var MAX_ATTEMPTS = 6;    // bounded -> no endless loop

  function refreshSwatchKing() {
    var name = 'vsk:product:refresh';
    var ev;
    try {
      ev = new Event(name, { bubbles: true, cancelable: false });
    } catch (e) {
      ev = document.createEvent('Event');
      ev.initEvent(name, true, false);
    }
    document.dispatchEvent(ev);
  }

  function clearGuards(section) {
    if (!section) return;
    section.removeAttribute('swatch-generated');
    try { delete section.vsk_initialized; }
    catch (e) { try { section.vsk_initialized = undefined; } catch (e2) {} }
  }

  function rendered(section) {
    // a real SwatchKing image/colour swatch exists once a .swatch-view-item is present
    return !!(section && section.querySelector('.swatch-view-item'));
  }

  // Nudge SwatchKing to (re)generate this holder's product-full swatches until
  // they appear, then stop -> guarantees a single, non-duplicated swatch set.
  // Only ONE run per holder is allowed at a time, and each tick first checks
  // whether the swatches already rendered (from SwatchKing's own pass or a prior
  // tick) before clearing/regenerating, so we never stack a second set.
  var running = {};
  function fixHolder(holder) {
    if (!holder || !holder.id) return;
    if (running[holder.id]) return;
    running[holder.id] = true;

    var attempt = 0;
    function done() { running[holder.id] = false; }

    function tick() {
      var section = holder.querySelector(SECTION_SELECTOR);
      if (section && rendered(section)) { done(); return; } // already good -> no dup
      if (section) {
        clearGuards(section);
        refreshSwatchKing();
      }
      if (++attempt < MAX_ATTEMPTS) {
        window.setTimeout(tick, RETRY_GAP);
      } else {
        done();
      }
    }
    window.setTimeout(tick, FIRST_DELAY);
  }

  function holderForHandle(handle) {
    return handle ? document.getElementById(HOLDER_PREFIX + handle) : null;
  }

  function start() {
    if (!document.body) return;

    // Trigger only when the user OPENS the Quick Shop modal: at that point the
    // content is visible and the per-product swatch-data fetch is most likely
    // complete. (Triggering earlier, on the hidden hover-preload, drove a second
    // generation pass and produced duplicate swatch blocks.)
    document.addEventListener('click', function (e) {
      var t = e.target;
      var trigger = t && t.closest
        ? t.closest('.quick-product__btn, [class*="js-modal-open-quick-modal"]')
        : null;
      if (!trigger) return;
      var card = trigger.closest('.grid-product');
      var handle = card && card.dataset ? card.dataset.productHandle : null;
      fixHolder(holderForHandle(handle));
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
